import { type BlogArticleCollectionResponse } from '@/modules/blog/types';
import { getContentfulData } from '@/modules/cms/api';
import { isNotNull } from '@/modules/cms/helpers/isNotNull';
import { isProduction } from '@/modules/env/isProduction';

export async function getBlogArticles({
  limit,
  skip,
}: {
  limit: number;
  skip: number;
}) {
  const query = `query blogArticleCollectionQuery {
        blogArticleCollection(preview: ${!isProduction()}, order: publishedAt_DESC, limit: ${limit}, skip: ${skip}) {
          items {
            title
            slug
            publishedAt
            thumbnail {
              url
              width
              height
              description
            }
          }
        }
      }`;
  const res = await getContentfulData<BlogArticleCollectionResponse>({ query });

  return res?.data?.data?.blogArticleCollection?.items?.filter(isNotNull);
}
